<template>
  <DBForm :store="store" :config="settings" :data="data" ref="form">
    <template v-slot="formSlot">
      <Card :panelFun="controller.panelFun.value" :panel="panel.key">
        <div class="writeoff-item-sheet">
          <p class="text-muted small mb-3">
            Выберите партию по карточке М-17 на складе из шапки акта, при необходимости скорректируйте количество.
          </p>

          <div class="form-row align-items-end">
            <div class="col-12 col-sm-2 col-lg-1">
              <DBEdit :form="formSlot" field="position_number" />
            </div>
            <div class="col-12 col-sm-10 col-lg-11">
              <DBEdit :form="formSlot" field="medicament_stock_id" typeahead clear />
            </div>
          </div>

          <div class="form-row">
            <div class="col-12">
              <DBEdit :form="formSlot" field="product_name" />
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4">
              <DBEdit :form="formSlot" field="batch_number" />
            </div>
            <div class="col-md-4">
              <DBEdit :form="formSlot" field="expiry_date" />
            </div>
            <div class="col-md-4">
              <DBEdit :form="formSlot" field="manufacturer" />
            </div>
          </div>

          <div class="form-row">
            <div class="col-6 col-md-3">
              <DBEdit :form="formSlot" field="unit_id" />
            </div>
            <div class="col-6 col-md-3">
              <DBEdit :form="formSlot" field="_stock_balance" />
            </div>
            <div class="col-6 col-md-3">
              <DBEdit :form="formSlot" field="quantity_packages" />
            </div>
            <div class="col-6 col-md-3">
              <DBEdit :form="formSlot" field="line_amount" />
            </div>
          </div>

          <div class="form-row mb-0">
            <div class="col-12">
              <DBEdit :form="formSlot" field="journal_ref" />
            </div>
          </div>
        </div>
      </Card>
    </template>
  </DBForm>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import EditController from "@/core/EditController";

export default defineComponent({
  name: "MedicamentWriteoffItemRowEdit",
  props: {
    panel: { type: Object, default: () => ({}) },
    store: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    data: { type: Object, default: () => ({}) },
    copy: { type: Boolean, default: false },
    defaults: { type: Object, default: () => ({}) },
    payload: { type: Object, default: null },
    params: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const form = ref(null);
    const controller = new EditController(form, props);
    return controller.setup();
  },
});
</script>

<style scoped>
.writeoff-item-sheet {
  padding: 0.25rem 0.15rem 0;
}

.writeoff-item-sheet .form-row + .form-row {
  margin-top: 0.65rem;
}

@media (min-width: 768px) {
  .writeoff-item-sheet {
    padding-left: 0.35rem;
    padding-right: 0.35rem;
  }
}
</style>
